
export const PageStates = {
    Add: 'Add',
    Assigned: 'Assigned',
    Boarding: 'Boarding',
    BoardingHelicopter: 'BoardingHelicopter',
    BoardingType: 'BoardingType',
    BoardingVessel: 'BoardingVessel',
    BridgeTime: 'BridgeTime',
    BridgeTimeDay: 'BridgeTimeDay',
    BridgeTimeNight: 'BridgeTimeNight',
    Busy: 'Busy',
    Confirm: 'Confirm',
    DateTime: 'DateTime',
    Default: 'Default',
    Delete: 'Delete',
    Deleting: 'Deleting',
    Deviation: 'Deviation',
    Edit: 'Edit',
    EditImage: 'EditImage',
    Error: 'Error',
    Executed: 'Executed',
    ExtraPay: 'ExtraPay',
    FetchFailed: 'FetchFailed',
    Harbours: 'Harbours',
    HourCompensation: 'HourCompensation',
    Invalid: 'Invalid',
    List: 'List',
    Location: 'Location',
    Main: 'Main',
    Map: 'Map',
    More: 'More',
    MissingData: 'MissingData',
    NoAccess: 'NoAccess',
    NotPilot: 'NotPilot',
    None: 'None',
    Observations: 'Observations',
    Offline: 'Offline',
    Overtime: 'Overtime',
    Pdf: 'Pdf',
    MainPdf: 'MainPdf',
    PilotAssignment: 'PilotAssignment',
    PilotType: 'PilotType',
    Receipt: 'Receipt',
    Reload: 'Reload',
    Remark: 'Remark',
    Responsibility: 'Responsibility',
    Retract: 'Retract',
    Search: 'Search',
    SearchLocations: 'SearchLocations',
    SelectNewImage: 'SelectNewImage',
    SelectType: 'SelectType',
    SelectTypeEdit: 'SelectTypeEdit',
    Ship: 'Ship',
    Swap: 'Swap',
    ValidateAccess: 'ValidateAccess',
    WaitingHoursReasonType: 'WaitingHoursReasonType',
    Welcome: 'Welcome',
    PilotStationSelector: 'PilotStationSelector',
    ExaminerPilotageHours: 'ExaminerPilotageHours',
    Archive: 'Archive'
}

export const Tokens = {
    Token: 'id_token'
}

export const NavItemTypes = {
    Default: 'DEFAULT',
    RefreshData: 'REFRESH_DATA',
    Login: 'LOGIN',
    Logout: 'LOGOUT',
    NewVersion: 'NEW_VERSION',
    About: 'ABOUT',
    Pcs: 'PCS',
    Settings: 'SETTINGS',
    Rotation: 'ROTATION',
    Header: 'HEADER',
    Impersonate: 'IMPERSONATE',
}

export const IconColors = {
    Primary: 'var(--icon-primary-fill)',
    Secondary: 'var(--icon-secondary-fill)',
    Active: 'var(--icon-active-fill)',
    InActive: 'var(--icon-inactive-fill)',
    Disabled: 'var(--icon-disabled-fill)',
    Error: 'var(--icon-error-fill)',
    Warning: 'var(--icon-warning-fill)',
    Ship: 'var(--icon-ship-fill)',
    ShipDefault: 'var(--icon-ship-default-fill)',
    ShipPilotVessel: 'var(--icon-ship-pilot-vessel-fill)',
    ShipCargo: 'var(--icon-ship-cargo-fill)',
    ShipTanker: 'var(--icon-ship-tanker-fill)',
    ShipPassenger: 'var(--icon-ship-passenger-fill)',
    ShipFish: 'var(--icon-ship-fish-fill)',
    ShipTug: 'var(--icon-ship-tug-fill)',
    ShipAuxillary: 'var(--icon-ship-auxillary-fill)',
    Pin: 'var(--icon-pin-fill)',
    PinStart: 'var(--icon-pin-start-fill)',
    PinStop: 'var(--icon-pin-stop-fill)',
    PinLocation: 'var(--icon-pin-location-fill)',
    AssignmentConfirmed: 'var(--icon-assignment-confirmed-fill)',
    AssignmentAssigned: 'var(--icon-assignment-assigned-fill)'

}

export const Sizes = {
    Default: 'default',
    Small: 'small',
    Medium: 'medium',
    Large: 'large',
    XLarge: 'xlarge'
}

export const ItemStates = {
    Default: 'Default',
    Edit: 'Edit',
    Delete: 'Delete'
}

export const PilotRotationStates = {
    ReadOnly: 'READONLY',
    Edit: 'EDIT',
    Counter: 'COUNTER'
}

export const PilotRotationTypes = {
    Standard: 'STANDARD',
    Change: 'CHANGE'
}

export const WorkTimePeriodStates = {
    Default: 'Default',
    Edit: 'Edit',
    Delete: 'Delete'
}

export const WorkTimeStampTypes = {
    REALTIME: 'REALTIME',
    MANUAL_OVERRIDDEN: 'MANUAL_OVERRIDDEN',
    AUTO_GENERATED: 'AUTO_GENERATED'
}

export const PilotActualWorkTimeStateEnum = {
    SUCCESS: 'SUCCESS',
    NOT_PILOT: 'NOT_PILOT',
    MISSING_DATES: 'MISSING_DATES',
    MISSING_WORKTIME_PERIODS: 'MISSING_WORKTIME_PERIODS'
}

export const IndexedDbNames = {
    Database: 'PilotWebDB',
    MetaStore: 'MetaStore',
    LocationStore: 'LocationStore',
    PilotagePilotStore: 'PilotagePilotStore',
    PilotageStore: 'PilotageStore',
    DepartmentStore: 'DepartmentStore',
    EvaluationStore: 'EvaluationStore',
    PilotBoardingTypeStore: 'PilotBoardingTypeStore',
    PilotagePilotTypeStore: 'PilotagePilotTypeStore',
    ManeuverResponsibleTypeStore: 'ManeuverResponsibleTypeStore',
    HourCompensationTypeStore: 'HourCompensationTypeStore',
    VariableCompensationOverrideReasonTypeStore: 'VariableCompensationOverrideReasonTypeStore',
    PilotagePilotWaitingHoursReasonTypeStore: 'PilotagePilotWaitingHoursReasonTypeStore',
    SelectedPilotStationStore: 'SelectedPilotStationStore',
    PilotagePilotOvertimeActivityTypeStore: 'PilotagePilotOvertimeActivityTypeStore'
}

export const IndexedDbKeyNames = {
    Token: 'token',
    CacheLastExpireDate: 'CacheLastExpireDate',
    WhoAmI: 'WhoAmI',
    EvaluationForm: 'evaluation-form',
    EvaluationList: 'evaluation-list',
    DayTime: 'DayTime',
    Configuration: 'Configuration',
    PreferencesMapMini: 'PreferencesMapMini',
    MapExpanded: 'MapExpanded',
    FavouriteStations: 'FavouriteStations',
    FavouritePilotTransportContacts: 'FavouritePilotTransportContacts',
    Modules: 'Modules'
}

export const HttpStatusCodes = {
    Ok: 200,
    NoContent: 204
}

export const PilotCoastalSegmentGroupLocationTypes = {
    General: 'GENERAL',
    Special: 'SPECIAL'
}

export const HistoryTypes = {
    WorkTime: 'WORKING_TIME',
    RestTime: 'RESTING_TIME',
    AvailableTime: 'AVAILABLE',
    OvertimeTravelTime: 'ARRIVAL_OVERTIME_TRAVEL',
    Appointment: 'Appointment',
    Piloting: 'Piloting',
}

export const PilotAssignmentStatusEnums = {
    Assigned: 'ASSIGNED',
    Confirmed: 'CONFIRMED',
    Rejected: 'REJECTED',
    Not_Processed: 'NOT_PROCESSED',
    Completed: 'COMPLETED',
    CorrectionNeeded: 'CORRECTION_NEEDED'
}

export const PilotBoardingTypeEnums = {
    None: "NONE",
    Helicopter: "HELICOPTER",
    PilotBoat: "PILOT_BOAT",
    NotApplicable: "NOT_APPLICABLE"
}

export const PilotOvertimeStatusEnum = {
    AwaitingPilotCompletion: "AWAITING_PILOT_COMPLETION",
    AwaitingApproval: "AWAITING_APPROVAL",
    AwaitingPaymentAuthorization: "AWAITING_PAYMENT_AUTHORIZATION",
    CorrectionNeeded: "CORRECTION_NEEDED",
    PassedForPayment: "PASSED_FOR_PAYMENT",
    ExportedToSalarySystem: "EXPORTED_TO_SALARY_SYSTEM"
}

export const PilotHourCompensationStatusEnum = {
    AwaitingPilotCompletion: "AWAITING_PILOT_COMPLETION",
    AwaitingApproval: "AWAITING_APPROVAL",
    AwaitingPaymentAuthorization: "AWAITING_PAYMENT_AUTHORIZATION",
    CorrectionNeeded: "CORRECTION_NEEDED",
    PassedForPayment: "PASSED_FOR_PAYMENT",
    ExportedToSalarySystem: "EXPORTED_TO_SALARY_SYSTEM"
}

export const PilotagePilotVariableCompensationTypeEnums = {
    BoardingVessel:	"BOARDING_VESSEL",
    BoardingHelicopter:	"BOARDING_HELICOPTER",
    BridgeTimeDay: "BRIDGE_TIME_DAY",
    BridgeTimeNight: "BRIDGE_TIME_NIGHT",
    InconvenienceAllowance: "INCONVENIENCE_ALLOWANCE",
}

export const PilotagePilotVariableCompensationOverrideReasonTypeEnums = {
    Other: "OTHER",
    SequentialPiloting: "SEQUENTIAL_PILOTING",
    MultiplePilotagesWithinOneHour: "MULTIPLE_PILOTAGES_WITHIN_ONE_HOUR",
    SharingCabin: "SHARING_CABIN"
}

export const PilotAssignmentStatusColors = {
    Confirmed: "#EFCC65",
    Assigned: "#2d8696",
    Completed: "#33A271",
    Rejected: "#D34B5B",
    Tentative: "#889BAA",
    CorrectionNeeded: "#de6441",
    NotProcessed: ""
}
export const PilotageExemptionApplicationStatusEnum = {
    APPLIED: "APPLIED",
    DISMISSED: "DISMISSED",
    SENT_TO_PILOT_MASTER: "SENT_TO_PILOT_MASTER",
    CONSIDERED_EVIDENTLY_JUSTIFIABLE: "CONSIDERED_EVIDENTLY_JUSTIFIABLE",
    CONSIDERED_NOT_EVIDENTLY_JUSTIFIABLE: "CONSIDERED_NOT_EVIDENTLY_JUSTIFIABLE",
    GRANTED: "GRANTED",
    REJECTED: "REJECTED",
    VOYAGE_ENDED: "VOYAGE_ENDED"
}

export const PilotageExemptionApplicationStatusColors = {
    APPLIED: "#70808e",
    DISMISSED: "#d34b5b",
    SENT_TO_PILOT_MASTER: "#efcc65",
    CONSIDERED_EVIDENTLY_JUSTIFIABLE: "#efcc65",
    CONSIDERED_NOT_EVIDENTLY_JUSTIFIABLE: "#efcc65",
    GRANTED: "#33a271",
    REJECTED: "#d34b5b",
    VOYAGE_ENDED: "#d34b5b"
}

export const SearchResultSettings = {
    SearchDialogMaxWindowWidth: 670
}

export const RouteGuardStates = {
    Busy: 'Busy',
    Valid: 'Valid',
    NoAccess: 'NoAccess',
    Offline: 'Offline',
    Login: 'Login'
}

export const CompensationType = {
    HourCompensation: 'HourCompensation',
    Overtime: 'Overtime',
    PilotageHourCompensation: 'PilotageHourCompensation',
    PilotageOvertime: 'PilotageOvertime',
    VariableCompensation: 'VariableCompensation',
    PilotageCompensation: 'PilotageCompensation'
}

export const WorkTimeActivityType = {
    Piloting: "PILOTING",
    Travel: "TRAVEL",
    Rest: "REST",
    OnboardExaminer: "ONBOARD_EXAMINER",
    OnboardTrainee: "ONBOARD_TRAINEE",
    TravelMultiplePilotsPilotage: "MULTIPLE_PILOTS_TRAVEL_24H",
    PilotingMultiplePilotsPilotage: "MULTIPLE_PILOTS_PILOTAGE_PILOTING_24H",
    RestingMultiplePilotsPilotage: "MULTIPLE_PILOTS_PILOTAGE_RESTING_24H",
    Meeting: "MEETING",
    Course: "COURSE",
    UnexpectedWaitingTime: "UNEXPECTED_WAITING_TIME",
    AdministrativeWorkPilotage: "ADMINISTRATIVE_WORK_PILOTAGE",
    AdministrativeWork: "ADMINISTRATIVE_WORK",
    Preparation: "PREPARATION",
    MidJourneyStop: "MID_JOURNEY_STOP",
}

export const WorkTimePeriodType = {
    WorkingTime: "WORKING_TIME",
    RestingTime: "RESTING_TIME",
    Available: "AVAILABLE",
    ArrivalOvertimeTravel: "ARRIVAL_OVERTIME_TRAVEL"
}

export const LocationType = {
    Dispatch : 'DISPATCHER',
    Office : 'OFFICE',
    Station: 'STATION',
    Harbour: 'HARBOUR',
    Quay: 'QUAY',
}

export const PilotageViewTypes = {
    Assigned: "ASSIGNED",
    Executed: "EXECUTED"
}

export const PersonAttributeNames = {
    PilotCode: "PILOT_CODE",
    PilotCertificateRemark: "PILOT_CERTIFICATE_REMARK",
    IsSensor: "IS_SENSOR",
    IsPilotTrainee: "IS_PILOT_TRAINEE",
    ExportedToAgressoDate: "EXPORTED_TO_AGRESSO_DATE",
    IsPecCaseworkerTrainee: "IS_PEC_CASEWORKER_TRAINEE"
}

export const pilotageOrderType = {
    PilotIncl: "PILOT_INCL",
    PilotExcl: "PILOT_EXCL"
}
